import { PageHero } from "../components/site/PageHero";
import { Residential } from "../components/site/Feature";
import { Process } from "../components/site/Process";
import { CTABand } from "../components/site/CTABand";

export default function ResidentialPage() {
  return (
    <>
      <PageHero
        eyebrow="Residential HVAC"
        title="Home comfort, every season."
        subtitle="Professional residential HVAC service to keep your home comfortable in every season."
      />
      <Residential />
      <Process />
      <CTABand />
    </>
  );
}
